import React, { forwardRef } from "react";
import { Datepicker as ReactDatepicker } from "@mobiscroll/react";
import cx from "classnames";
import PropTypes from "prop-types";

import styles from "./Timepicker.module.scss";

const Timepicker = forwardRef(
  ({ className, onChange, onClose, placeholder, value, ...rest }, ref) => (
    <div className={cx(styles.wrapper, className)}>
      <ReactDatepicker
        ref={ref}
        timeFormat="hh:mm A"
        themeVariant="light"
        controls={["time"]}
        theme="ios"
        stepMinute={1}
        value={value}
        onChange={(data) => onChange && onChange(data)}
        onClose={(data) => onClose && onClose(data)}
        inputProps={{
          placeholder,
        }}
        {...rest}
      />
    </div>
  )
);

Timepicker.defaultProps = {
  className: "",
  placeholder: "",
  value: "",
  onChange: () => {},
  onClose: () => {},
};

Timepicker.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onClose: PropTypes.func,
  value: PropTypes.string,
};

export default Timepicker;
